import { create } from "zustand";
import { NotificationAPI } from "../api";
import { NotificationHistoryItem } from "../api/transformers/notification";
import { first } from "lodash";

type NotificationHistoryStore = {
  data: NotificationHistoryItem[],
  loading: boolean;
  error: unknown;
  getLatestNotification: () => NotificationHistoryItem | undefined;
  fetchData: (personId: string, keepPreviousData?: boolean) => void;
}

const useNotificationHistoryStore = create<NotificationHistoryStore>((set, get) => ({
  data: [],
  loading: true,
  error: null,
  // actions
  getLatestNotification: () => first(get().data),
  fetchData: async (personId, keepPreviousData = false) => {
    set({ loading: true, error: null, data: keepPreviousData ? get().data : [] });
    try {
      const result = await NotificationAPI.getInvestorNotificationHistory(personId);
      set({ data: result, loading: false });
    } catch (err) {
      console.error(err);
      set({ error: err, loading: false });
    }
  }
}));

export default useNotificationHistoryStore;
